<template>
  <div>
    <van-button type="primary" @click="scan">扫一扫</van-button>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
// import api from "../../common/js/api";
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  created() {
    // this.getWxConfig();
  },

  mounted() {},

  methods: {
    // getWxConfig() {
    //   let urlNow = encodeURIComponent(window.location.href.split("#")[0]);
    //   this.$post(api.wxConfig, { url: urlNow }).then((res) => {
    //     wx.config({
    //       // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       debug: true,
    //       // 必填，公众号的唯一标识
    //       appId: "wx3fbf6f30ae7bb620",
    //       // 必填，生成签名的时间戳
    //       timestamp: "1626073286",
    //       // 必填，生成签名的随机串
    //       nonceStr: "69edde48fc0847c9",
    //       // 必填，签名
    //       signature: "06c36c3bd6912af56c3f08cb355a173efcf243f7",
    //       // 必填，需要使用的JS接口列表，所有JS接口列表
    //       jsApiList: ["scanQRCode"],
    //     });
    //   });

    //   wx.error(function (res) {
    //     this.$toast(res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
    //   });
    // },
    scan() {
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维，默认二者都有
          success: function (res) {
            var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果码
            alert("扫描结果：" + result);
          },
        });
      });
    },
  },
};
</script>
<style lang='scss' scoped>
</style>